import { interpolateString } from '@/utils/toolkit/string/interpolate-string.utils';
import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({ name: 'interpolate' })
export class InterpolatePipe implements PipeTransform {
    transform(textToInterpolate: string, interpolationParams: any): string {
        return interpolateString(textToInterpolate, interpolationParams);
    }
}
